import { RouteRecordRaw, Router, RouterScrollBehavior } from 'vue-router';

import { trackEvent } from '@app/composables/posthog';

const NotFoundView = () => import('../views/NotFound.vue');

/**
 * Both entries need a 404 fallback, since either bundle can be served an unknown path by
 * the host's SPA rewrite.
 */
export const notFoundRoutes: RouteRecordRaw[] = [
  {
    path: '/404',
    name: 'NotFound',
    component: NotFoundView
  },
  {
    path: '/:catchAll(.*)', redirect: '404'
  }
];

export const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  // Scrolling is a client-only concern; during prerendering there is no document.
  if (import.meta.env.SSR) return;

  if (savedPosition) {
    return savedPosition;
  } else if (to.hash) {
    setTimeout(() => {
      document.getElementById(to.hash.replace('#', ''))?.scrollIntoView({behavior: "smooth"});
    }, 100);
  } else {
    document.getElementById("app")?.scrollIntoView({behavior: "smooth"});
  }
};

export const registerRouterTracking = (router: Router) => {
  router.afterEach((to, from) => {
    trackEvent('page_viewed', {
      page_name: to.name as string,
      page_path: to.path,
      from_page: from.name as string,
    });
  });
};
